import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { NgxPaginationModule } from "ngx-pagination";
import { UserListComponent } from "./user-list.component";

@NgModule({
    declarations: [
      UserListComponent
    ],
    imports: [
      FormsModule,
      CommonModule,
      RouterModule,
      NgxPaginationModule
    ]
})
export class UserListModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/admin/user/list/user-list.module.ts